import { Stack } from "@mui/material";

const Success = ({ children }) => {
  return (
    <Stack
      direction={"column"}
      sx={{
        alignItems: "center",
        justifyContent: "center",
        background: "#D1FADF",
        border: "8px solid #ECFDF3",
        width: "fit-content",
        borderRadius: "50%",
        padding: "4px",
      }}
    >
      {children}
    </Stack>
  );
};

export default Success;
